import Login from "@/pages/login";
import Register from "@/pages/register";
import ForgotPassword from "@/pages/forgotPassword";
import IdeaSoftLogin from '@/pages/login/ideaSoftLogin';

import Overview from "@/pages/overview";
import SubMerchants from "@/pages/subMerchants";
import SubMerchantSession from "@/pages/subMerchantSession";
import Inbox from "@/pages/inbox";
// Products
import Products from "@/pages/products";
import ProductEditPage from "@/pages/products/productEditPage";
import ProductCreatePage from "@/pages/products/productCreatePage";

// Products From Integrations
import ProductsFromIntegrations from "@/pages/productsFromIntegrations";
import ProductFromIntegrationsEditPage from "@/pages/productsFromIntegrations/productEditPage";

// Customers
import IndividualCustomers from "@/pages/individualCustomers";
import CorporateCustomers from "@/pages/corporateCustomers";
import CustomerCorporateEditPage from "@/pages/corporateCustomers/customerEditPage";

// Claims
import ServiceClaims from "@/pages/claims/ServiceClaims";
import ServiceRecords from "@/pages/claims/ServiceRecords";
import SetupClaims from "@/pages/claims/SetupClaims";
import SetupClaimDetailPage from "@/pages/claims/SetupClaims/ClaimEditPage";
import ServiceClaimDetailPage from "@/pages/claims/ServiceClaims/ClaimEditPage";

import ServiceRecordDetailPage from "@/pages/claims/ServiceRecords/ClaimEditPage";
import ServiceRecordCreatePage from "@/pages/claims/ServiceRecords/ClaimCreatePage";

// Applications
import Applications from "@/pages/applications";
import ApplicationInstallPage from "@/pages/applications/applicationInstallPage";
import ApplicationEditPage from "@/pages/applications/applicationEditPage";

//
import InfobipInstallPage from "@/pages/applications/customized/infobip/applicationInstallPage";
import InfobipEditPage from "@/pages/applications/customized/infobip/applicationEditPage";
import VerimorInstallPage from "@/pages/applications/customized/merchant-verimor-integrations/applicationInstallPage";
import VerimorEditPage from "@/pages/applications/customized/merchant-verimor-integrations/applicationEditPage";
import JetsmsInstallPage from "@/pages/applications/customized/merchant-jetsms-integrations/applicationInstallPage";
import JetsmsEditPage from "@/pages/applications/customized/merchant-jetsms-integrations/applicationEditPage";

// Settings
import Settings from "@/pages/settings";
import AccountSettings from "@/pages/settings/accountSettings";
import Documents from "@/pages/settings/documents";
import DocumentEditPage from "@/pages/settings/documents/documentEditPage";
import DocumentCreatePage from "@/pages/settings/documents/documentCreatePage";
import MissingDocumentsPage from "@/pages/settings/documents/missing";
import Employees from "@/pages/settings/employees";
import CreateEmployee from "@/pages/settings/employees/createEmployee";
import EditEmployee from "@/pages/settings/employees/editEmployee";
import ActivationsPage from "@/pages/settings/activations";
import LanguageSettings from "@/pages/settings/language";
import ServiceActivationDetails from "@/pages/settings/activations/serviceActivation/activationDetails";
import ProductActivation from "@/pages/settings/activations/productActivation";
import PaymentSettings from '@/pages/settings/payment';
import AddCreditCard from '@/pages/settings/payment/addCreditCard';



import PrivateRoutes from "@/components/privateRoutes";
import MainLayout from "@/components/layout/mainLayout";

// Sellers
import Sellers from "@/pages/sellers";
import ViewSeller from "@/pages/sellers/ViewSeller";
import WaitingSellers from "@/pages/sellers/WaitingSellers";
import OnboardSeller from "@/pages/sellers/onboardSeller";
import { Checkout } from "@/pages/settings/payment/checkout";
import StatusPage from "@/pages/settings/payment/statusPage";
import NotFound from "@/pages/notFound";

import GlobalError from "@/errorBoundary";
import ExtendedWarranties from "@/pages/extendedWarranties/transactions";
import ExtendedWarrantyDetail from "@/pages/extendedWarranties/transactions/detail";
import SaleReports from "@/pages/extendedWarranties/saleReports";
import Candidates from "@/pages/extendedWarranties/candidates";
import NewPackage from "@/pages/extendedWarranties/transactions/newPackage";
import Packages from "@/pages/extendedWarranties/packages";
import PackageDetail from "@/pages/extendedWarranties/packages/detail";
import NewPackagePage from "@/pages/extendedWarranties/packages/newPackagePage";
import SendWarrantyPage from "@/pages/products/sendWarrantyPage";

// Campaigns
import Campaigns from "@/pages/campaigns";
import CampaignCreatePage from "@/pages/campaigns/campaignCreatePage";
import CampaignEditPage from "@/pages/campaigns/campaignEditPage";

const routes = [
  {
    path: "/",
    element: <PrivateRoutes />,
    errorElement: <GlobalError />,
    children: [
      // PRIVATE ROUTES
      // Main Layout
      {
        path: "/",
        element: <MainLayout />,
        children: [
          // Overview
          { path: "/", element: <Overview /> },
          {
            path: "/inbox",
            element: <Inbox />,
          },
          // Sub Merchants
          { path: "/sub-merchants", element: <SubMerchants /> },
          // Products
          { path: "/products/products", element: <Products /> },
          {
            path: "/products/integrations",
            element: <ProductsFromIntegrations />,
          },
          // Customers
          { path: "/customers/individual", element: <IndividualCustomers /> },
          { path: "/customers/corporate", element: <CorporateCustomers /> },
          // Claims
          { path: "/claims/service", element: <ServiceClaims /> },
          { path: "/claims/setup", element: <SetupClaims /> },
          { path: "/claims/service-record", element: <ServiceRecords /> },
          // Applications
          { path: "/applications", element: <Applications /> },
          // Settings
          { path: "/settings", element: <Settings /> },
          { path: "/settings/account", element: <AccountSettings /> },
          { path: "/settings/documents", element: <Documents /> },
          { path: "/settings/documents/missing", element: <MissingDocumentsPage /> },
          { path: "/settings/employees", element: <Employees /> },
          { path: "/settings/activations", element: <ActivationsPage /> },
          {
            path: "/settings/language",
            element: <LanguageSettings />,
          },
          // Sellers
          {
            path: "/sellers",
            element: <Sellers />,
          },
          // Campaigns
          { path: "/campaigns", element: <Campaigns /> },
          // Extended Warranties
          { path: "/extended-warranties/transactions", element: <ExtendedWarranties /> },
          { path: "/extended-warranties/packages", element: <Packages /> },
          { path: "/extended-warranties/sale-reports", element: <SaleReports /> },
          { path: "/extended-warranties/candidates", element: <Candidates /> },
        ],
      },
      { path: "/products/products/:id", element: <ProductEditPage /> },
      { path: "/products/products/create", element: <ProductCreatePage /> },
      {
        path: "/products/sendWarranty",
        element: <SendWarrantyPage />,
      },
      {
        path: "/products/integrations/:id",
        element: <ProductFromIntegrationsEditPage />,
      },
      // Customers
      {
        path: "/customers/corporate/:id",
        element: <CustomerCorporateEditPage />,
      },
      // Claims
      {
        path: "/claims/service/:id",
        element: <ServiceClaimDetailPage />,
      },
      {
        path: "/claims/setup/:id",
        element: <SetupClaimDetailPage />,
      },
      {
        path: "/claims/service-record/:id",
        element: <ServiceRecordDetailPage />,
      },
      {
        path: "/claims/service-record/create",
        element: <ServiceRecordCreatePage />,
      },
      {
        path: "/extended-warranties/transactions/:id",
        element: <ExtendedWarrantyDetail />,
      },
      {
        path: "/extended-warranties/transactions/new",
        element: <NewPackage />,
      },
      {
        path: "/extended-warranties/packages/:id",
        element: <PackageDetail />,
      },
      {
        path: "/extended-warranties/packages/new",
        element: <NewPackagePage />,
      },
      // Applications
      { path: "/applications/infobip", element: <InfobipInstallPage /> },
      { path: "/applications/infobip/edit", element: <InfobipEditPage /> },
      { path: "/applications/verimor", element: <VerimorInstallPage /> },
      { path: "/applications/verimor/edit", element: <VerimorEditPage /> },
      { path: "/applications/jetsms", element: <JetsmsInstallPage /> },
      { path: "/applications/jetsms/edit", element: <JetsmsEditPage /> },

      { path: "/applications/:name", element: <ApplicationInstallPage /> },
      { path: "/applications/:name/edit", element: <ApplicationEditPage /> },
      // Documents
      { path: "/settings/documents/:id", element: <DocumentEditPage /> },
      { path: "/settings/documents/create", element: <DocumentCreatePage /> },
      // Settings
      { path: "/settings/employees/create", element: <CreateEmployee /> },
      { path: "/settings/employees/:id", element: <EditEmployee /> },
      {
        path: "/settings/activations/service",
        element: <ServiceActivationDetails />,
      },
      {
        path: "/settings/activations/product",
        element: <ProductActivation />,
      },
      {
        path: "/settings/payment",
        element: <PaymentSettings />,
      },
      {
        path: "/settings/payment/add-credit-card",
        element: <AddCreditCard/>,
      },
      {
        path: "/settings/payment/checkout",
        element: <Checkout/>,
      },
      {
        path: "/settings/payment/status",
        element: <StatusPage/>,
      },
      // Sellers
      {
        path: "/sellers/:id",
        element: <ViewSeller />,
      },
      {
        path: "/sellers/waiting",
        element: <WaitingSellers />,
      },
      // Campaigns
      {
        path: "/campaigns/create",
        element: <CampaignCreatePage />,
      },
      {
        path: "/campaigns/:id",
        element: <CampaignEditPage />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/idea-soft/login",
    element: <IdeaSoftLogin />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/request-demo",
    element: <Register />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/sellers/onboarding",
    element: <OnboardSeller />
  },
  // EPS-5027: ana bayinin actigi yeni sekme; token'i alip panele yonlendirir.
  {
    path: "/sub-merchant/session",
    element: <SubMerchantSession />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
